module.exports = __webpack_public_path__ + "img/color_block_2.8fa0add4.svg";